/* =============================================
   BOLD SURFACES — Variant Room Scene Gallery
   Handles tab switching + variant change image swap
   v2 — no-shift: uses visibility instead of display
   ============================================= */

(function () {
  var gallery = document.querySelector('[data-room-scene-gallery]');
  if (!gallery) return;

  var tabs = gallery.querySelectorAll('[data-tab]');
  var tilePanel = gallery.querySelector('[data-panel="tile"]');
  var roomPanel = gallery.querySelector('[data-panel="room"]');
  var dawnGallery = document.querySelector('.product__media-wrapper media-gallery');

  /* ---- Tile badge (variant name overlay on Dawn gallery) ---- */
  // Only create the badge if there is at least one variant with a face_image to read from.
  // Otherwise (e.g. subway tiles) the badge would render as an empty black box.
  var tileBadge = null;
  var hasAnyFaceImage = roomPanel && roomPanel.querySelector('[data-variant-id]');
  if (dawnGallery && hasAnyFaceImage) {
    var firstSlide = dawnGallery.querySelector('.product__media-item');
    var badgeParent = firstSlide || dawnGallery;
    badgeParent.style.position = 'relative';
    tileBadge = document.createElement('span');
    tileBadge.className = 'mv-room-scene__badge mv-room-scene__badge--tile';
    badgeParent.appendChild(tileBadge);
  }

  function updateTileBadge() {
    if (!tileBadge) return;
    var vid = getVariantFromUrl() || getVariantFromInput();
    if (!vid) {
      tileBadge.textContent = current_variant_title || '';
      return;
    }
    // Find matching variant title from the faces panel data attributes
    var match = roomPanel ? roomPanel.querySelector('[data-variant-id="' + vid + '"]') : null;
    if (match) {
      var badge = match.querySelector('.mv-room-scene__badge');
      tileBadge.textContent = badge ? badge.textContent.trim() : '';
    }
  }

  // Store initial variant title from the page
  var current_variant_title = '';
  var initialBadge = roomPanel ? roomPanel.querySelector('[data-variant-id]:not([style*="display:none"]) .mv-room-scene__badge, [data-variant-id]:not([style*="display: none"]) .mv-room-scene__badge') : null;
  if (initialBadge) {
    current_variant_title = initialBadge.textContent.trim();
  }
  if (tileBadge) {
    tileBadge.textContent = current_variant_title;
  }

  /* ---- Tab switching ---- */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.getAttribute('data-tab');

      // Update active tab
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');

      if (target === 'tile') {
        // Show Dawn gallery, hide faces
        if (dawnGallery) {
          dawnGallery.style.display = '';
        }
        roomPanel.classList.remove('is-active');
        tilePanel.classList.add('is-active');
      } else {
        // Hide Dawn gallery, show faces
        if (dawnGallery) {
          dawnGallery.style.display = 'none';
        }
        tilePanel.classList.remove('is-active');
        roomPanel.classList.add('is-active');
      }
    });
  });

  /* ---- Variant change listener ---- */

  var tabsContainer = gallery.querySelector('.mv-room-scene__tabs');
  var facesTab = gallery.querySelector('[data-tab="room"]');
  var tileTab = gallery.querySelector('[data-tab="tile"]');

  function updateTabsVisibility(variantId) {
    if (!tabsContainer || !roomPanel) return;
    var hasFace = roomPanel.querySelector('[data-variant-id="' + variantId + '"]');
    if (hasFace) {
      tabsContainer.style.display = '';
    } else {
      tabsContainer.style.display = 'none';
      // If currently on Faces tab, switch back to Tile
      if (roomPanel.classList.contains('is-active')) {
        roomPanel.classList.remove('is-active');
        tilePanel.classList.add('is-active');
        if (dawnGallery) dawnGallery.style.display = '';
        if (facesTab) facesTab.classList.remove('is-active');
        if (tileTab) tileTab.classList.add('is-active');
      }
    }
  }

  function swapRoomImage(variantId) {
    if (!roomPanel) return;
    var images = roomPanel.querySelectorAll('[data-variant-id]');
    var found = false;
    images.forEach(function (img) {
      if (String(img.getAttribute('data-variant-id')) === String(variantId)) {
        img.style.display = '';
        found = true;
      } else {
        img.style.display = 'none';
      }
    });
    if (!found) {
      // No face image for this variant — don't show a misleading fallback
    }
    updateTabsVisibility(variantId);
  }

  function getVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function getVariantFromInput() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  // Initial check: hide tabs if current variant has no face image
  var initialVid = getVariantFromUrl() || getVariantFromInput();
  if (initialVid) {
    updateTabsVisibility(initialVid);
  }

  // Method 1: Listen for change events on variant pickers
  document.querySelectorAll('variant-selects, variant-radios').forEach(function (picker) {
    picker.addEventListener('change', function () {
      setTimeout(function () {
        var vid = getVariantFromUrl() || getVariantFromInput();
        if (vid) {
          swapRoomImage(vid);
          updateTileBadge();
        }
      }, 200);
    });
  });

  // Method 2: popstate for back/forward
  window.addEventListener('popstate', function () {
    var vid = getVariantFromUrl();
    if (vid) {
      swapRoomImage(vid);
      updateTileBadge();
    }
  });

  // Method 3: Observe hidden input value changes instead of polling
  var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (variantInput) {
    var observer = new MutationObserver(function () {
      var vid = variantInput.value;
      swapRoomImage(vid);
      updateTileBadge();
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    // Fallback: listen for programmatic value changes via change event
    variantInput.addEventListener('change', function () {
      swapRoomImage(variantInput.value);
      updateTileBadge();
    });
  }

  /* ---- Lightbox (matches Dawn modal style) ---- */
  var lightbox = document.createElement('div');
  lightbox.className = 'mv-lightbox';
  lightbox.innerHTML =
    '<button class="mv-lightbox__close" type="button" aria-label="Close"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
    '<div class="mv-lightbox__inner"><img class="mv-lightbox__img" src="" alt=""></div>' +
    '<span class="mv-lightbox__badge"></span>';
  document.body.appendChild(lightbox);

  var lbImg = lightbox.querySelector('.mv-lightbox__img');
  var lbInner = lightbox.querySelector('.mv-lightbox__inner');
  var lbBadge = lightbox.querySelector('.mv-lightbox__badge');
  var lbClose = lightbox.querySelector('.mv-lightbox__close');

  /* Zoom / pan state */
  var isZoomed = false;
  var isDragging = false;
  var dragStart = { x: 0, y: 0 };
  var panOffset = { x: 0, y: 0 };

  function resetZoom() {
    isZoomed = false;
    isDragging = false;
    panOffset = { x: 0, y: 0 };
    lbInner.classList.remove('is-zoomed', 'is-dragging');
    lbImg.style.transformOrigin = 'center center';
    lbImg.style.transform = '';
  }

  function applyPan() {
    lbImg.style.transform = 'scale(2.5) translate(' + panOffset.x + 'px, ' + panOffset.y + 'px)';
  }

  function openLightbox(src, badgeText) {
    lbImg.src = src;
    lbBadge.textContent = badgeText;
    resetZoom();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    resetZoom();
  }

  /* Click to toggle zoom */
  lbInner.addEventListener('click', function (e) {
    if (isDragging) return; // ignore drag-end clicks
    if (!isZoomed) {
      // Zoom in at click point
      var rect = lbInner.getBoundingClientRect();
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;
      lbImg.style.transformOrigin = xPct + '% ' + yPct + '%';
      isZoomed = true;
      panOffset = { x: 0, y: 0 };
      lbInner.classList.add('is-zoomed');
    } else {
      resetZoom();
    }
  });

  /* Mouse drag to pan when zoomed */
  var dragMoved = false;
  lbInner.addEventListener('mousedown', function (e) {
    if (!isZoomed || e.button !== 0) return;
    isDragging = true;
    dragMoved = false;
    dragStart.x = e.clientX - panOffset.x;
    dragStart.y = e.clientY - panOffset.y;
    lbInner.classList.add('is-dragging');
    e.preventDefault();
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    dragMoved = true;
    panOffset.x = e.clientX - dragStart.x;
    panOffset.y = e.clientY - dragStart.y;
    applyPan();
  });

  document.addEventListener('mouseup', function () {
    if (!isDragging) return;
    lbInner.classList.remove('is-dragging');
    isDragging = false;
    // Suppress click if user dragged
    if (dragMoved) {
      setTimeout(function () { dragMoved = false; }, 10);
    }
  });

  /* Suppress zoom-toggle on drag release */
  var origClickHandler = lbInner.onclick;
  lbInner.addEventListener('click', function (e) {
    if (dragMoved) { e.stopImmediatePropagation(); dragMoved = false; }
  }, true);

  /* Touch: drag to pan when zoomed */
  lbInner.addEventListener('touchstart', function (e) {
    if (!isZoomed || e.touches.length !== 1) return;
    isDragging = true;
    dragMoved = false;
    dragStart.x = e.touches[0].clientX - panOffset.x;
    dragStart.y = e.touches[0].clientY - panOffset.y;
    lbInner.classList.add('is-dragging');
  }, { passive: true });

  lbInner.addEventListener('touchmove', function (e) {
    if (!isDragging) return;
    dragMoved = true;
    panOffset.x = e.touches[0].clientX - dragStart.x;
    panOffset.y = e.touches[0].clientY - dragStart.y;
    applyPan();
    e.preventDefault();
  }, { passive: false });

  lbInner.addEventListener('touchend', function () {
    if (!isDragging) return;
    lbInner.classList.remove('is-dragging');
    isDragging = false;
    if (dragMoved) {
      setTimeout(function () { dragMoved = false; }, 10);
    }
  });

  // Click face image → open lightbox
  if (roomPanel) {
    roomPanel.addEventListener('click', function (e) {
      var img = e.target.closest('.mv-room-scene__img');
      if (!img) return;
      var wrapper = img.closest('.mv-room-scene__image');
      var badge = wrapper ? wrapper.querySelector('.mv-room-scene__badge') : null;
      var badgeText = badge ? badge.textContent.trim() : '';
      var src = img.src.replace(/width=\d+/, 'width=2400');
      openLightbox(src, badgeText);
    });
  }

  lbClose.addEventListener('click', function (e) {
    e.stopPropagation();
    closeLightbox();
  });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });
})();
